import { MaterialRequestRecord } from '../../../../types/MaterialRequest';
import React from 'react';
import { Descriptions } from 'antd';
import StatusTag from '../../../../components/ui/StatusTag';

interface MaterialRequestInfoViewProps {
  data?: MaterialRequestRecord | undefined;
}
const MaterialRequestInfoView: React.FC<MaterialRequestInfoViewProps> = ({
  data,
}) => {
  return (
    <>
      <Descriptions
        title="Material Request"
        style={{
          backgroundColor: 'white',
          padding: '16px',
          borderRadius: '0.25rem',
        }}
      >
        <Descriptions.Item label="Code">{data?.code}</Descriptions.Item>
        <Descriptions.Item label="Required Date" span={2}>
          {data?.requiredDate}
        </Descriptions.Item>

        <Descriptions.Item label="Source Location">
          {data?.location?.description}
        </Descriptions.Item>
        <Descriptions.Item label="Destination">
          {data?.destination?.description}
        </Descriptions.Item>

        <Descriptions.Item label="Source Document">
          {data?.source}
        </Descriptions.Item>

        <Descriptions.Item label="Remarks">{data?.notes}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <StatusTag status={data?.status ?? ''} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default MaterialRequestInfoView;
